export default __webpack_public_path__ + "static/media/code_scan_case.01937569.png";